const contact = {
    title: 'Contato',
    submit: 'Mandar',
}

export default contact
